import TeamCard from "components/Card/TeamCard";
import TeamModal from "components/Modal/TeamModal";
import { lang } from "constant/lang";
import { teamsData } from "constant/team";
import dotsYellow from "images/pattern/dots-yellow.svg";
import dotsRed from "images/pattern/dots-red.svg";
import box1 from "images/pattern/box-1.svg";
import twirl1 from "images/pattern/twirl-1.svg";
import twirl2 from "images/pattern/twirl-2.svg";
import React, { useState } from "react";

const TeamTitle = () => {
  return (
    <div
      className="relative inline-flex items-center bg-wce-pink-bright px-4 md:px-6 rounded-3xl
          font-yesevaOne text-white text-2xl md:text-6.5xl h-12 md:h-20 w-fit mt-12 mb-10 md:mb-24"
    >
      {lang.about.team.title.first}&nbsp;
      <span className="font-yesevaOne text-wce-yellow">
        {lang.about.team.title.second}
      </span>
      {lang.about.team.title.third}
    </div>
  );
};

const TeamSection = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeTeam, setActiveTeam] = useState({});

  const firstCards = teamsData.slice(0, 2);
  const secondCards = teamsData.slice(2, 7);
  const thirdsCards = teamsData.slice(7, 16);

  const handleClick = (id) => {
    const team = teamsData.find((t) => t?.id === id);
    setActiveTeam(team);
    setShowModal(true);
  };

  return (
    <div className="flex relative mt-8 mb-16 md:mb-32">
      <div className="absolute right-0 bottom-96 translate-x-1/2">
        <img className="w-[140px] min-w-[140px]" src={twirl1} alt={"twirl1"} />
      </div>
      <div className="absolute left-0 bottom-8 -translate-x-1/2">
        <img className="w-[140px] min-w-[140px]" src={twirl2} alt={"twirl2"} />
      </div>
      <div className="absolute right-16 bottom-8">
        <img className="w-[65px] min-w-[65px]" src={box1} alt={"box1"} />
      </div>
      <div className="flex flex-col items-center max-w-7xl mx-auto">
        <TeamModal
          open={showModal}
          onClose={() => setShowModal(false)}
          team={activeTeam}
        />
        <div className="relative">
          <div className="absolute left-8 md:left-16 top-8 md:top-4 -translate-x-full">
            <img
              className="w-[70px] md:w-[140px] md:min-w-[140px]"
              src={dotsYellow}
              alt={"dotsYellow"}
            />
          </div>
          <div className="absolute right-4 md:right-8 bottom-4 md:bottom-16 translate-x-full">
            <img
              className="w-[70px] md:w-[140px] md:min-w-[140px]"
              src={dotsRed}
              alt={"dotsRed"}
            />
          </div>
          <TeamTitle />
        </div>
        <div className="relative">
          <div className="absolute -left-96 -bottom-6">
            <img className="w-[84px] min-w-[84px]" src={box1} alt={"box1"} />
          </div>
          <div className="font-yesevaOne text-wce-yellow text-xl md:text-3xl mb-4 md:mb-10">
            {lang.about.team.p1}
          </div>
        </div>
        <div className="flex flex-wrap justify-center mb-10 md:mb-20 gap-5 md:gap-20">
          {firstCards.map((team) => (
            <TeamCard
              onClick={() => handleClick(team?.id)}
              team={team}
              order="1"
            />
          ))}
        </div>
        <div className="relative">
          <div className="absolute -right-96 -top-16">
            <img className="w-[84px] min-w-[84px]" src={box1} alt={"box1"} />
          </div>
          <div className="font-yesevaOne text-wce-yellow text-xl md:text-3xl mb-4 md:mb-10">
            {lang.about.team.p2}
          </div>
        </div>
        <div className="flex flex-wrap justify-center mb-10 md:mb-20 gap-5 md:gap-6">
          {secondCards.map((team) => (
            <TeamCard
              onClick={() => handleClick(team?.id)}
              team={team}
              order="2"
            />
          ))}
        </div>
        <div className="relative">
          <div className="font-yesevaOne text-wce-yellow text-xl md:text-3xl mb-4 md:mb-10">
            {lang.about.team.p3}
          </div>
        </div>
        <div className="flex flex-wrap justify-center gap-5 md:gap-6">
          {thirdsCards.map((team) => (
            <TeamCard
              onClick={() => handleClick(team?.id)}
              team={team}
              order={"3"}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamSection;
